/**
 * Date Formats used throughout the UI.
 */
export enum DateFormats {
  /**
   * For cases in which we display date and time.
   */
  StandardDateTime = 'YYYY年MM月DD日HH時mm分'
}
